import { EvtHeader } from "components/header";
import React from "react";
import { useParams } from "react-router-dom";
import TechStackForm from "../form";

const UpdateTechStack = () => {
  const { techStackId } = useParams();

  return (
    <div className="flex-1 max-w-md">
      <EvtHeader title="Update Tech Stack" />
      <div className="p-6 max-w-2xl">
        <TechStackForm techStackId={techStackId} />
      </div>
    </div>
  );
};

export default UpdateTechStack;
